import styled from 'styled-components';

import { COLOR } from 'constants/color';

export const CustomCreateButton = styled.div`
  button {
    border: none;
    color: ${COLOR.purpel['purpel-6']};
    margin: 7px auto 23px auto;
    background: transparent;
    font-size: 16px;
    line-height: calc(22 / 16);
    font-weight: 600;
    svg path {
      stroke: ${COLOR.purpel['purpel-6']} !important;
    }
    &:hover {
      background-color: #ffffff;
      color: ${COLOR.purpel['purpel-6']};
    }
  }
`;

export const LearnerModal = styled.div`
  .es-modal {
    width: 848px;
    max-height: 800px;
    overflow: auto;
  }

  .es-modal-header {
    font-size: 22px;
    line-height: 30px;
    font-weight: 500;
    color: ${COLOR.surfaceNeutralBold['neutral-11']};
    padding: 16px 18px 0 24px;
    svg {
      width: 24px;
      height: 24px;
    }
    svg path {
      stroke: ${COLOR.surfaceNeutralBold['neutral-11']} !important;
    }
  }
`;

export const CollapseIcon = styled.div`
  width: 24;
  height: 24;
  margin-top: 4px;
  svg path {
    stroke: ${COLOR.purpel['purpel-6']};
  }
`;

export const CreateButton = styled.div`
  button {
    font-size: 18px;
    line-height: 26px;
    font-weight: 600;
  }
`;

export const Group = styled.div`
  margin: 0 -16px;
  padding: 28px 16px 32px;
  border-bottom: 1px solid ${COLOR.neutralTrans['neutralTrans-15']};
`;
